import { render, staticRenderFns } from "./TeamJigsFilters.vue?vue&type=template&id=b08495a0"
import script from "./TeamJigsFilters.vue?vue&type=script&lang=ts"
export * from "./TeamJigsFilters.vue?vue&type=script&lang=ts"
import style0 from "./TeamJigsFilters.vue?vue&type=style&index=0&id=b08495a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports